import React from "react";
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import { format } from "d3-format"
import CircleIcon from '@mui/icons-material/Circle';
import CvdMikroCardssmall from "../../../../../components/Cards/CVDMikroCards_small";
import DiaTextHeart from "../InfoText/DiaTextHeart";

const tmao = 5.9
const tmao_warning_low = 6.2;
const tmao_warning_red = 9.9;



export default function GutHeartAxisCard(data) {

return (
<>
<CvdMikroCardssmall  
  
content = {<>      

<Grid container>  
            
    <Grid item xs={12}>
    
            <Grid container> 
               <Grid item xs={11}>  <Typography variant="h3" color='common.white' sx={{p:1}}> GUT - HEART AXIS </Typography>   </Grid>
               <Grid item xs={1}> <DiaTextHeart /> </Grid>
            </Grid>
    </Grid>

    <Grid item xs={12} sx={{ p:1,  }} >

                <Typography   variant="h3" color='primary.light' 
                              sx={{fontFamily: 'Poppins', fontWeight: '400', fontSize: {sx: '55%', sm: '45%', md: '175%', lg: '180%', xl: '300%' },
                                
                            color: 'traffic.green', 
                              ...(tmao > tmao_warning_low && {color: 'traffic.orange'}), 
                              ...(tmao > tmao_warning_red && {color: 'traffic.red'}), 
                                }}> 
                  {format(",")( tmao )}&nbsp;<Typography component="span" variant="body1"> µM TMAO metabolites </Typography><br />
                        
            </Typography>
    </Grid>

    <Grid item xs={12} sx={{ pl:1 }} > 
            <Typography variant='h6 'sx={{ color: 'common.white', fontFamily: 'Poppins', fontWeight: '200', fontSize: '0.8rem'}} >
            Reference:  &nbsp;  {'<'} 6.2 µM TMAO level
        </Typography>
    </Grid>
                                
                          </Grid>

            <Grid item xs={12} sx={{ mt:4}}>
            <Typography variant="h6" color='common.white' sx={{p:1, fontWeight: '600', fontSize: {sx: '55%', sm: '45%', md: '75%', lg: '90%', xl: '95%' },    }}>
            ANALYSIS: &nbsp; GUT - HEART AXIS
            </Typography>
            
            <Typography variant="h6" color='common.white' sx={{p:2, fontWeight: '400', fontSize: {sx: '55%', sm: '45%', md: '75%', lg: '90%', xl: '90%' },    }}> 
                        <Grid container sx={{alignItems: 'center', justifyContent: 'center'}}>
                            <Grid item xs={6} >                           
                                    Collinsella<br />
                                    Enterobacter<br />
                                    Megamonas<br />
                                    Streptococcus<br />
                                    Bacteroides<br />
                                    Blautia<br />
                                    Faecalibacterium<br />
                                    Roseburia<br />
                            </Grid>
                            <Grid item xs={2} > 
                            <CircleIcon sx={{fontSize: '110%', color: 'traffic.green', }}></CircleIcon><br />
                            <CircleIcon sx={{fontSize: '110%', color: 'traffic.green', }}></CircleIcon><br />
                            <CircleIcon sx={{fontSize: '110%', color: 'traffic.green', }}></CircleIcon><br />
                            <CircleIcon sx={{fontSize: '110%', color: 'traffic.green', }}></CircleIcon><br />
                            <CircleIcon sx={{fontSize: '110%', color: 'traffic.red', }}></CircleIcon><br />
                            <CircleIcon sx={{fontSize: '110%', color: 'traffic.green', }}></CircleIcon><br />
                            <CircleIcon sx={{fontSize: '110%', color: 'traffic.green', }}></CircleIcon><br />
                            <CircleIcon sx={{fontSize: '110%', color: 'traffic.green', }}></CircleIcon>                     
                                    
                            </Grid>
                        </Grid>
            </Typography>
            
        </Grid>
 
           
    </>}   
    />    
</>
)};
  